<div class="header">
	<div class="content" [ngClass]="{'menuShowing': true}">
		<div class="contentInner">
			<div class="pageTitle" appReveal>
			  <!-- Only the guide index is titled "User guide". On an article this is just a
			       label, and the article's own heading is the page h1. -->
			  <h1 *ngIf="selectedArticle === null" class="headline">User guide</h1>
			  <div *ngIf="selectedArticle !== null" class="headline">User guide</div>
			</div>
		</div>
    <div class="topicTabsContainer">
      <div class="menuNotifier" tabindex="0" role="link" (click)="toggleNavbar()" (keypress)="toggleNavbar()">{{activeTabLabel}}</div>
      <div class="topicTabs" [ngClass]="{ 'open': navbarOpen }">
        <a *ngFor="let tab of navTabs" [routerLink]="tab.link" class="topicTab" [ngClass]="{ 'selected': tab.article === selectedArticle }" (click)="closeNavbar()">{{tab.navLabel}}</a>
      </div>
      <div class="chevron" [ngClass]="{ 'open': navbarOpen }" tabindex="0" role="link" (click)="toggleNavbar()" (keypress)="toggleNavbar()"></div>
    </div>
	</div>
</div>

<div class="content menu" *ngIf="selectedArticle === null">
  <div class="contentInner">
    <p class="intro">Set up Dash on your device, master its features, and learn how to get the most out of Dash for
      your organization.  Our user guide has everything you need to know.</p>
    <p  class="intro">Can't find the answer you're looking for here?  <a routerLink="/contact">Contact us</a> and we'll be happy to help.
    </p>
    <div class="topicButtons">
      <a class="topic quickStart" routerLink="quickStart"><app-illustration class="icon" alt="Quick start" src="/assets/images/guide-quickstart.png" webpSrc="/assets/images/guide-quickstart.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Quick Start Guide</div><p>A quick guide to getting Dash up and running.</p></a>
      <a class="topic officeSetup" routerLink="officeSetup"><app-illustration class="icon" alt="Microsoft 365 setup" src="/assets/images/guide-microsoft.png" webpSrc="/assets/images/guide-microsoft.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Microsoft 365 setup</div><p>Set up Microsoft 365 and connect it to Dash.</p></a>
      <a class="topic googleSetup" routerLink="googleSetup"><app-illustration class="icon" alt="Google setup" src="/assets/images/guide-google.png" webpSrc="/assets/images/guide-google.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Google <br>setup</div><p>Set up Google Workspace or personal Google account, and connect it to Dash.</p></a>
      <a class="topic exchangeCalendarSetup" routerLink="exchangeCalendarSetup"><app-illustration class="icon" alt="Other calendar service setup" src="/assets/images/guide-exchange.png" webpSrc="/assets/images/guide-exchange.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Exchange & other setup</div><p>Set up Dash to work with another calendar service (such as an on-prem Exchange Server or CalDav).</p></a>
      <a class="topic deviceSetup" routerLink="deviceSetup"><app-illustration class="icon" alt="Android/iOS setup setup" src="/assets/images/guide-ios-android.png" webpSrc="/assets/images/guide-ios-android.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Device setup</div><p>Install Dash on your device, lock it down, and get it running.</p></a>
      <a class="topic usingDash" routerLink="usingDash"><app-illustration class="icon" alt="Using Dash" src="/assets/images/guide-dash.png" webpSrc="/assets/images/guide-dash.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Using Dash</div><p>A comprehensive guide to everything Dash.</p></a>
      <a class="topic enterprise" routerLink="/enterprise"><app-illustration class="icon" alt="Dash Enterprise" src="/assets/images/guide-enterprise.png" webpSrc="/assets/images/guide-enterprise.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Dash Enterprise</div><p>Centrally manage your Dash displays with Dash Enterprise.</p></a>
      <a class="topic practices" routerLink="practices"><app-illustration class="icon" alt="Practices" src="/assets/images/guide-practices.png" webpSrc="/assets/images/guide-practices.webp" width="400" height="400" [cover]="true" [clickable]="false"></app-illustration><div class="title">Practices</div><p>Helpful hints on getting the most out of Dash.</p></a>
    </div>
  </div>
</div>

<div class="content quickStart" *ngIf="selectedArticle === 'quickStart'">
  <div class="contentInner">
    <h1 class="sectionHeader">Getting Started with Dash</h1>
    <p class="intro">
      Follow these steps to be up and running with Dash in no time.  Install Dash from the App Store, Google Play Store
      or the Amazon Appstore, connect it to your room calendar, choose a display mode, and lock the device down. This
      takes about 15 minutes for the first device, and a few minutes per device for the others.
    </p>

    <h2 class="subHeading">1. Install Dash and activate your subscription (about 2 minutes)</h2>
    <p>
      Installing Dash is usually as easy as downloading it from the store on your device.  You can find detailed information
      in our <a routerLink="/guide/deviceSetup">device setup guide</a>.
    </p>
    <p>
      If you're still deciding which device to use, you can
      read our <a routerLink="/blog/how-to-choose-meeting-room-display-hardware">how to choose the right meeting room display hardware</a> guide.
    </p>

    <h2 class="subHeading">2. Connect your calendars (about 3 minutes)</h2>
    <p>If you are using <i>Microsoft 365</i> or <i>Google Workspace</i> then you can complete all the
      necessary steps from within Dash.  Please see our guides on <a routerLink="/guide/officeSetup">Microsoft 365 Setup</a> and
      <a routerLink="/guide/googleSetup">Google Setup</a> for instructions on how to set up your Microsoft 365/Google Workspace
      account correctly and connect it to Dash.
    </p>
    <p>
      If you are using a different system to manage your meeting room calendars (for example an on-prem <i>Exchange</i> server or
      <i>CalDav</i>) then you can connect your device to the service and Dash will read your meeting information from your
      device's calendar.  Please see the section on <i>Using Dash with your device's calendar</i> in our
      <a routerLink="/guide/exchangeCalendarSetup">Device calendar Setup</a> guide for information on how to do this.
    </p>

    <h2 class="subHeading">3. Lock down the device (about 2 minutes)</h2>
    <p>
      Did you know that you can lock your device to Dash, so that people walking past can't close the app and get to the
      home screen?  Both iOS and Android offer ways to do this (Guided Access and Screen Pinning, respectively) which you
      can configure by following the instructions in our <a routerLink="/guide/deviceSetup" fragment="locking">device setup guide</a>.
    </p>
    <p>
      If you're managing your devices with an MDM system (such as Intune), you can also configure your meeting room displays in
      <i>Single-app kiosk mode</i>.  This locks the device to Dash, sets Dash to start automatically with the device,
      and lets you block notifications and system menus.  For more information, see your MDM provider's guide or
      <a routerLink="/contact">contact us</a> for assistance.
    </p>

    <h2 class="subHeading">4. Choose how meetings are displayed (about 2 minutes)</h2>
    <p>
      Dash features a number of ways to customize the way your meeting information is displayed which can all be found
      in the <i>Calendar and display</i> section of Dash's settings.  Here are some of the most important settings:
    </p>
    <ol>
      <li><b>Display mode - </b>Dash has five different display modes to choose from, two that can show a single room and three that show multiple rooms on the same display:
        <ul>
          <li>Room Display - Dash's default display, which shows the status of a single room, along with a schedule.</li>
          <li>Countdown display - Shows a single room with a countdown ring showing the amount of time left in the current meeting (or the amount of free time left).  Intended for a display mounted inside the room, but it also works well as a display mounted at the door.</li>
          <li>Dashboard display - Shows the status of multiple meeting rooms on one display, arranged in a grid.  This is useful for displays mounted between several rooms, or large displays mounted in a central location.</li>
          <li>Schedule dashboard - Shows the status of multiple meeting rooms like the dashboard display, but also shows each room's full schedule.  It works best when mounted on a large display in a central location.</li>
          <li>What's on - Rather than showing multiple rooms, the What's on display shows a list of current and upcoming meetings across all of your selected rooms.  This works great on a large display at reception, where visitors can quickly find the room for their meeting.</li>
        </ul>
        You can find more information about Dash's display modes in our <a routerLink="/guide/usingDash">Using Dash</a> guide.
      </li>
      <li><b>Rename calendars - </b>Your meeting rooms might not always be named the way you want in your calendars.  If
        you find this is the case, Dash allows you to rename them.  Select <i>Rename calendars</i>, tap on the calendar
        you wish to rename, and enter your desired name.
      </li>
      <li>
        <b>Show room occupancy by color - </b>Dash displays a color based on the room's current status so that you can
        see if the room is free or busy at a glance.  By default, Dash will color the background of the room's schedule,
        but you can choose to display the color on a border around the display, or on the background of the entire display instead.
      </li>
      <li>
        <b>Dim screen after hours - </b>Choose your working hours and days, and Dash will dim the display outside these
        times to save power and prolong the life of your display device.  If you need to use the display after hours,
        just tap it to bring it back to life.
      </li>
      <li><b>Time format and Language - </b>These options control whether times are displayed in a 12 or 24 hour format,
        and which of the 26 supported languages is used in the main sections of the app.  Dash will choose the best
        defaults based on your Device's location settings, but you can override this and choose your own time format
        and language.  You can set the time and timezone in your device's settings app.
      </li>
    </ol>

    <h2 class="subHeading">5. Security (about 1 minute)</h2>
    <p>
      The <i>Security</i> section of Dash's settings gives you a number of controls which allow you to secure Dash's
      settings from unauthorized access and to control what meeting information is displayed on Dash's main display.
    </p>
    <ol>
      <li>
        <b>Require passcode to access settings - </b>If you wish to protect Dash's settings from unauthorized access,
        you can set a 4 digit passcode which must be entered before Dash's settings will open.  Turn on the option and
        enter your desired passcode twice to activate it.
      </li>
      <li>
        <b>Meeting Information - </b>If you have sensitive information in the titles of your meetings, you can use the
        <i>Label meetings with</i> setting to control what is displayed.  Choose from displaying the meeting's title,
        the meeting's organizer, or simply show that the room is booked without revealing the title or organizer.  When
        turned off, the <i>Display meeting details</i> setting will prevent the meeting's description and list of
        participants from being shown when a meeting is tapped on the main screen.
      </li>
    </ol>

    <h2 class="subHeading">6. Optional Features (about 3 minutes)</h2>
    <p>
      Dash offers a number of powerful features to help you manage your meeting rooms, available in the <i>Optional
    features</i> section.  The ideal combination of settings will differ from organization to organization so we
      recommend that you trial different settings before settling on the combination that works best for you.
    </p>
    <ol>
      <li>
        <b>Check-in - </b>One of the largest causes of meeting room inefficiency is abandoned bookings - meetings which
        are booked in the room but then not attended.  Dash can help to prevent these with the <i>Check-in</i> feature.
        When turned on, a Check-in button will be displayed on the main screen for each meeting.  If this button is not pressed
        within a set time after the meeting is scheduled to start, the room will be released from the meeting
        and made available for others.  You can also choose to release rooms from recurring meetings, if a set number
        of check-ins have been missed in a row.
      </li>
      <li>
        <b>Room booking - </b>Dash can also allow users to book the room directly from the screen.  When the <i>Allow
        booking</i> option is turned on, users will be able to book the room if it is available.  You can choose to enable booking for instant bookings, or for instant and later bookings:
        <ul>
          <li>Instant bookings will start from
            the time the <i>Book now</i> button is pressed, and users have a choice of booking the room for 15 minutes,
            30 minutes, 1 hour, or 2 hours.</li>
          <li>Later bookings are chosen from a calendar view, and can start at any time in the future</li>
        </ul>
        You can also choose to allow or require users to set a message with their bookings, set an organizer, and add attendees.
      </li>
      <li>
        <b>Ending and extending meetings - </b>If a meeting is running longer than expected, Dash can allow users to
        extend it if the room is available.  Conversely, if a meeting ends earlier than expected the booking can be
        ended early to free the room for other meetings.
      </li>
      <li>
        <b>Find free rooms - </b>If the room is currently booked, the <i>Find free rooms</i> feature allows users to find
        other free rooms in the building.  When turned on, the <i>Find free rooms</i> option adds a button to the main
        screen that lists all rooms currently free.  Select the rooms you want to include using the <i>Rooms to check</i>
        option and they will be displayed in the list.  The list is ordered by the amount of free time, so the room with
        the most free time is displayed first.
      </li>
    </ol>

    <h2 class="subHeading">7. Customize Branding (about 2 minutes)</h2>
    <p>
      Dash allows you to choose your own background image.  Dash supports any size of background image - the image
      chosen will be scaled so that it covers your devices display.  For best results, you should create an image that
      exactly matches the size of your device's display in pixels.  To find the ideal background image size for your
      device, open the <i>Appearance and branding</i> section of Dash's settings.  The ideal size will be shown just underneath
      the option for setting the background image.
    </p>
    <p>
      Dash also allows you to display a custom logo.  The chosen logo will appear at the top of the main screen.
      The ideal image size for a custom logo is 500 x 100 pixels, however you can use an image with a different size and
      it will be scaled to fit.  If you would like to have your logo appear in a different part of the main display you
      can add it to your background image instead of loading it separately.
    </p>
    <p>
      Dash also allows you to customize the colors of visual elements such as buttons, text, and dialog backgrounds.
      For a full list of the customization options please see the <i>Appearance and branding</i> section of our
      <a routerLink="/guide/usingDash">full guide</a>.
    </p>

    <p>&nbsp;</p>

    <p class="intro">Congratulations!  You have finished setting up Dash.  You can learn more about the available settings in our
      <a routerLink="/guide/usingDash">Full guide</a>, and if you have any questions or comments feel free to
      <a routerLink="/contact">Contact us</a> - we're here to help!</p>

    <h2 class="sectionHeader">Troubleshooting</h2>

    <h3>I don't see my meeting rooms in Dash</h3>
    <p>
      If you're using the <a routerLink="/guide/o365-service-account">Microsoft 365 business or personal account</a> or
      <a routerLink="/guide/google-personal-account">Dash to a Google Workspace standard, or personal account</a> connection
      methods, check that the account you're using with Dash can see all of your meeting rooms.  If you can see the rooms
      in Outlook or Google Calendar when signed in with the account, then you should be able to see them in Dash. The
      <a routerLink="/guide/o365-enterprise-application">Microsoft 365 Enterprise Application</a> or
      <a routerLink="/guide/google-service-account">Google Workspace service account</a> connection methods should be
      able to see all of your organization's meeting rooms by default.
    </p>

    <p>
      If you're using Microsoft 365 and have just created the meeting rooms in Exchange Online, you might have to wait.
      Microsoft takes some time (up to 24 hours) before it makes newly created room mailboxes available to 3rd party
      apps such as Dash, so if you're not seeing the room show up right away, try again in a couple of hours.
    </p>

    <h3>The device is showing the wrong time</h3>
    <p>
      Dash takes its time and timezone settings from your device.  If you're not seeing the correct time, you can change your device's
      timezone from Settings:
    </p>
    <h4>Apple devices</h4>
    <p>
      Open the Settings app, then go to <i>General -> Date & Time</i>.  You can set the date and time, or choose to have
      them be set automatically (recommended).
    </p>

    <h4>Android devices</h4>
    <p>
      Open the Settings app, then go to <i>System -> Date & time</i>.  You can set the date, time, and timezone from here,
      or choose to have them be set automatically (recommended).
    </p>

    <h3>I'm using Dash with Microsoft 365 and see the organizer's email address instead of meeting titles</h3>
    <p>
      By default, Microsoft 365 labels events in resource calendars with the meeting's organizer rather than its title.  If
      you would like to see your meetings displayed in Dash with their title, you can connect to your Microsoft 365
      instance via PowerShell, and then change the default settings for each room.  You can find
      instructions in <a routerLink="/guide/o365-powershell">our helpful guide</a>.
    </p>

    <p class="tip">If you don't see the answer to your issue above, please <a routerLink="/contact">contact us</a> and
    we'll be happy to help.</p>

  </div>
</div>


<div class="content officeSetup" *ngIf="selectedArticle === 'officeSetup'">
  <app-guide-o365 *ngIf="selectedSubArticle === null"></app-guide-o365>
  <app-guide-o365-service-account *ngIf="selectedSubArticle === 'o365-service-account'"></app-guide-o365-service-account>
  <app-guide-o365-enterprise-application *ngIf="selectedSubArticle === 'o365-enterprise-application'"></app-guide-o365-enterprise-application>
  <app-guide-o365-powershell *ngIf="selectedSubArticle === 'o365-powershell'"></app-guide-o365-powershell>
</div>


<div class="content googleSetup" *ngIf="selectedArticle === 'googleSetup'">
  <div class="contentInner">

    <app-guide-google *ngIf="selectedSubArticle === null"></app-guide-google>
    <app-guide-google-personal-account *ngIf="selectedSubArticle === 'google-personal-account'"></app-guide-google-personal-account>
    <app-guide-google-service-account *ngIf="selectedSubArticle === 'google-service-account'"></app-guide-google-service-account>






  </div>
</div>

<div class="content exchangeCalendarSetup" *ngIf="selectedArticle === 'exchangeCalendarSetup'">
  <div class="contentInner">
    <h1 class="sectionHeader">Using Dash with Exchange and other calendar services</h1>

    <p class="intro">
      If you're using a service other than Microsoft 365 and Google Workspace, you can set up Dash to work with your
      calendar system by connecting the service your device's built-in calendar and then configuring Dash to read events
      from your device.  If you can get your rooms and meetings to display in your device's built-in calendar app, then
      it will work with Dash.
    </p>


    <h2 class="sectionHeader">Setting up an on-prem Exchange Server to work with Dash</h2>
    <p>
      If you're connecting Dash to an on-prem Exchange server, follow the steps below to prepare the server first.  If
      you're connecting Dash to a different service, proceed directly to the <i>Adding calendars</i> section below.
    </p>

    <p>
      Your device (and therefore Dash) connects to Exchange using one or more user accounts, and as such Dash will have
      access to all the calendars that the account can see.  You will need to share your meeting room calendars with
      this account in order for them to be visible to your device and Dash.
    </p>

    <h3>Sharing your meeting room calendars</h3>
    <p>
      First you'll need to create a user account on your Exchange server to use with Dash.  Then (as an administrator)
      share your resource calendar with that account (giving it write access).  You can find instructions for sharing in
      <a href="https://answers.microsoft.com/en-us/outlook_com/forum/all/sharing-resource-calendars/0ca9dcb1-2c06-43bd-b9a0-692a30b55a95" target="_blank">Microsoft's online guide</a>.
      If you have more than one meeting room, repeat the procedure for each room until you can see all meeting room
      calendars in Outlook, when signed in with the user account you'll be using with Dash.
    </p>

    <h3>If calendar sharing doesn't work</h3>
    <p>
      Some Exchange servers do not allow devices signed in with an account to see shared calendars.  If this is the case
      for you, you can still use Dash with your Exchange server by connecting your device to each meeting room individually.
      To do this, for each meeting room:
    </p>

    <ol>
      <li>Open <i>Active Directory Users and Computers</i>.</li>
      <li>Select your domain in the navigation tree, then select  <i>Users</i>.</li>
      <li>Find your meeting room account in the list of users.</li>
      <li>Right click on the account, and choose <i>Reset password...</i>  Enter a new password for the account.</li>
      <li>Right click on the account, and choose <i>Properties</i>  Switch to the <i>Account</i> tab, and under <i>Account properties</i> make sure that <i>Account is disabled</i> is unchecked.</li>
    </ol>
    <p>
      Now on your device, add a new Exchange account, using the email address and password for the meeting room.  If you do this for each room, you should be able to see the calendars in Dash.  You can use Dash's <i>Rename calendars</i> feature to give each calendar an appropriate name - we recommend doing this each time you add a calendar as they will all come through with the name "Calendar".
    </p>


    <h2 class="sectionHeader">Adding calendars to your device</h2>

    <h3>Adding calendars to your iOS device</h3>
    <p>
      Go to the <i>Settings</i> app on your iPhone or iPad, and go to <i>Accounts & Passwords</i>.  Select the type of
      account you would like to add.  If you do not see your account type in the list, it may be listed under <i>Other</i>.  Follow the instructions on screen
      to enter your credentials and add the account to your device.
    </p>
    <p>
      You will have a choice of what information to sync between your account and your device (for example <i>Mail</i>,
      <i>Contacts</i>, and <i>Calendars</i>).  It is recommended to turn off everything except <i>Calendars</i> to speed
      up syncing.
    </p>

    <p>
      At the bottom of the <i>Accounts & Passwords</i> settings screen, you will see a <i>Fetch New Data</i> option.
      Select it and make sure that <i>Push</i> is turned on.  At the bottom of the screen you will see an option for
      <i>Fetch</i> frequency.  Make sure that this is set to <i>Automatically</i>.
    </p>

    <h3>Adding calendars to your Android device</h3>
    <p>
      Go to the <i>Settings</i> app on your phone or tablet, and go to <i>Accounts</i>.  Click <i>Add account</i> and select the type of
      account you would like to add (e.g. 'Exchange').  For some services not natively supported by your device (e.g. for CalDav) you will
      need to install a separate app that functions as a 'sync adapter' in order to see your service in this list.
      Once you have selected your service, follow the instructions on screen to enter your credentials and add your
      account to your device.
    </p>
    <p>
      Once your account has been added to your device, go to <i>Account sync</i>.  You will have a choice of what
      information to sync between your account and your device (for example <i>Mail</i>,
      <i>Contacts</i>, and <i>Calendars</i>).  It is recommended to turn off everything except <i>Calendar</i> to speed
      up syncing.
    </p>
    <p>
      You can now select your calendar from Dash.  Open Dash, go to Settings, choose the 'Calendar' option and select
      the calendar for your meeting room from the list.
    </p>

    <h2 class="sectionHeader">Troubleshooting</h2>

    <h3>I don't see my meeting room calendars in Dash</h3>
    <p>
      Dash can see all the calendars added to your device.  Double check by opening your device's built-in calendar app.
      If you can see your calendar in the app and not in Dash, please <a routerLink="/contact">contact us</a> for assistance.
      If you do not see your room in the calendar app, double check that the account has been added correctly to your device.
      If you've just added the account, it can take some time for all calendars to sync, so we recommend waiting to see
      if your room shows up.
    </p>

    <h3>My meeting room calendar is not showing updates in Dash / my meeting room calendar has stopped syncing</h3>
    <p>
      Dash regularly asks your device to sync its calendars, but there are several things that can interfere with this:
    </p>
    <ul>
      <li>A full sync of all data can take a long time, so make sure you've set the account to just sync calendar information.  You can find instructions for this in the connection guide above</li>
      <li>Some newer versions of Android place restrictions on how apps can request the calendars to sync.  Recent versions of Dash work around this, so we recommend using Dash 1.5.26 or later.</li>
    </ul>

    <h3>I can't book my meeting room from Dash</h3>
    <p>
      Your device needs to be able to make changes to events in the meeting room's calendar in order for Dash to book the room.
      If you are using calendar sharing with an account, you may need to give the account write access to the meeting room calendar(s)
      to enable booking.
    </p>
    <p>
      Some connection types are read only, so make sure that you are using a connection that allows you to make changes
      to events.  If you need help, please <a routerLink="/contact">contact us</a> for assistance.
    </p>


  </div>
</div>

<div class="content deviceSetup" *ngIf="selectedArticle === 'deviceSetup'">
  <div class="contentInner">

    <h1 class="sectionHeader">Android and iOS device setup</h1>
    <p class="intro">Installing Dash on your device is straightforward, but there are some differences between
      platforms.  This guide shows you how to install Dash on your device, activate your subscription, and lock the
      device down so that Dash can't be closed.</p>

    <p class="tip icon">
      Not sure which device to use? See our <a routerLink="/hardware">hardware guide</a> for supported devices, or
      read <a routerLink="/blog/how-to-choose-meeting-room-display-hardware">how to choose the right meeting room display hardware</a>.
    </p>

    <h2 class="sectionHeader">Installing Dash</h2>
    <p>
      If you have an Apple device, Fire Tablet, or Android Tablet with the Google Play Store, you can install Dash from one of the stores:
    </p>
    <div class="storeButtonContainer">
        <a href="https://apps.apple.com/us/app/dash-meeting-room-display/id1481443382" (click)="plausible.trackClick($event, 'App Store Click')"><img ngSrc="../assets/images/app-store-badge.svg" width="133" height="40" alt="Download on App Store"></a>
        <a href="https://play.google.com/store/apps/details?id=nz.co.aptsoftware" (click)="plausible.trackClick($event, 'Play Store Click')"><img ngSrc="../assets/images/play-store-badge.svg" width="133" height="40" alt="Download on Play Store"></a>
        <a href="https://www.amazon.com/gp/product/B0D4DY15WY" (click)="plausible.trackClick($event, 'Amazon Store Click')"><img ngSrc="../assets/images/amazon-store-badge.svg" width="133" height="40" alt="Download on Amazon App Store"></a>
    </div>
    <p>
      If you have an Android device without the Play Store, you can install Dash manually using our official APK.  If you
      have a <a routerLink="/about-enterprise">Dash Enterprise</a> subscription, you can download our latest APK from the <i>Organization</i> section of the
      web dashboard.  If you don't have a Dash Enterprise subscription, please <a routerLink="/contact">contact us</a>
      to get access to the latest APK.
    </p>
    <p>
      If you're using a smart TV or commercial display that requires a web app, <a routerLink="/about-enterprise">Dash Enterprise</a>
      has a web version of Dash that you can use.  Please see <a routerLink="/enterprise/web-app">our documentation</a> for
      more information.
    </p>

    <h2 class="sectionHeader">Setting up your subscription</h2>
    <p>
      Dash works great as a read-only display without a subscription, but if you have a subscription you can activate it on your device:
    </p>
    <h2>Dash Business in-app subscription</h2>
    <p>
      Our in-app subscriptions are linked through the account the app store is signed in to.  Make sure that each device
      is signed in to the same store account that was used to purchase your subscription, and it should be picked up
      automatically when you open the Dash app.
    </p>
    <p class="tip icon">Sometimes the device can keep using the store account that was signed in when Dash was first installed.
    If you've just changed the signed in store account and aren't seeing your subscription in Dash, try uninstalling
    and re-installing the app.</p>
    <h2>Dash Business or Dash Enterprise annual subscriptions</h2>
    <p>
      Our annual subscriptions are licensed via a key.  To activate your device, open the subscription section of Dash's
      settings, tap <i>Enterprise license</i> (or <i>Pairing code</i> on Apple devices) then enter your key.  If you
      have a <a routerLink="/about-enterprise">Dash Enterprise</a> subscription you can also enter a pairing code you've
      obtained from the web management dashboard here.  Please see <a routerLink="/enterprise/dashboard-configuration" fragment="add-device">our documentation</a>
      for more information.
    </p>

    <h2 class="sectionHeader" id="locking">Locking your device</h2>
    <p class="intro">
      The following settings can be used to lock your device to stop people from closing Dash and accessing other apps.
      When enabled, users will have to enter a pin code before they can close Dash.
    </p>

    <p class="tip icon">Remember to also set a pin code for Dash's settings screen, so that only admins can change
      Dash's settings.  You'll find this option in the <i>Security</i> section of Dash's settings.
    </p>

    <h3>Guided Access (iOS devices)</h3>
    <p>
      <i>Guided Access</i> is an optional feature on your device that restricts users to using only a single application.
      It can be used to prevent users from closing Dash (for example if your meeting room screen is in a public place)
    </p>
    <p>
      To learn more about Guided access and how to enable it for your device, visit the
      <a href="https://support.apple.com/HT202612">Apple support page</a> on the topic.  Once you have set up <i>Guided
      Access</i>, open Dash and activate <i>Guided Access</i> by triple clicking the home button of your device (or the
      side button if your device does not have a home button) and tapping <i>Start</i>.
    </p>
    <p>
      You may also wish to disable the sleep/wake button of your device.  To do this, triple click the home button to
      activate <i>Guided Access</i> and then tap <i>Options</i> and disable the sleep/wake button before tapping
      <i>Start</i>.
    </p>

    <h3>Screen pinning (Android devices)</h3>
    <p>
      <i>Screen pinning</i> is an optional feature on android devices running version 5.0 (Lollipop) or later that
      restricts users to using only a single application. It can be used to prevent users from closing Dash
      (for example if your meeting room screen is in a public place).
    </p>
    <p>
      To learn more about <i>screen pinning</i> and how to enable it for your device, visit the
      <a href="https://support.google.com/android/answer/9455138">Google support page</a> on the topic.  Once you have
      set up <i>Screen pinning</i>, open Dash and activate <i>Screen pinning</i> from the Android <i>Overview</i> view
      (see the above <i>Google</i> documentation for further instructions).
    </p>

    <h3>MDM Kiosk mode (Apple and Android devices)</h3>
    <p>
      If your devices are managed by an MDM system, you can configure them in single-app kiosk mode.  This locks the
      device to Dash, makes Dash start automatically with the device, and allows you to hide system menus and notifications.
      You can find more information in your MDM system's documentation, or <a routerLink="/contact">contact us</a> for help.
    </p>
  </div>
</div>




<div class="content usingDash" *ngIf="selectedArticle === 'usingDash'">
  <div class="contentInner">
    <h1 class="sectionHeader">Using Dash</h1>
    <h2 class="sectionHeader" id="mainScreen">The main display</h2>
    <p class="intro">This is the main meeting display.  From here you can see details of current meetings, look at
      the day's schedule, or make a new booking.  Dash's main display can be set to one of five modes.
    </p>
    <p>
      See below the illustration for detailed information about each part of the display for each mode, and see the
      <a routerLink="." fragment="configuration">configuration section</a> for how to select the display mode.
    </p>

    <div class="toggleContainer">
      <div role="link" href="#" [ngClass]="{ 'selected': overviewIllustration === 'room' }" (click)="toggleOverviewIllustration('room')" (keypress)="toggleOverviewIllustration('room')">Room display</div>
      <div role="link" href="#" [ngClass]="{ 'selected': overviewIllustration === 'countdown' }" (click)="toggleOverviewIllustration('countdown')" (keypress)="toggleOverviewIllustration('countdown')">Countdown display</div>
      <span class="break-marker"></span>
      <div role="link" href="#" [ngClass]="{ 'selected': overviewIllustration === 'dashboard' }" (click)="toggleOverviewIllustration('dashboard')" (keypress)="toggleOverviewIllustration('dashboard')">Dashboard display</div>
      <div role="link" href="#" [ngClass]="{ 'selected': overviewIllustration === 'scheduleDashboard' }" (click)="toggleOverviewIllustration('scheduleDashboard')" (keypress)="toggleOverviewIllustration('scheduleDashboard')">Schedule dashboard</div>
      <div role="link" href="#" [ngClass]="{ 'selected': overviewIllustration === 'whatsOn' }" (click)="toggleOverviewIllustration('whatsOn')" (keypress)="toggleOverviewIllustration('whatsOn')">What's on</div>
    </div>
    <p class="displayModeDescription" *ngIf="overviewIllustration === 'room'">The default Dash room display gives you a clear overview of the room's current status, as well as it's overall schedule.  Ideal for a device mounted outside the door.</p>
    <p class="displayModeDescription" *ngIf="overviewIllustration === 'countdown'">The countdown display emphasizes the time remaining in the current meeting.  Ideal for a device mounted inside the meeting room.</p>
    <p class="displayModeDescription" *ngIf="overviewIllustration === 'dashboard'">The dashboard display shows the status of multiple meeting rooms.  Ideal for a device mounted by several nearby rooms, or a TV mounted in a central location.</p>
    <p class="displayModeDescription" *ngIf="overviewIllustration === 'scheduleDashboard'">The schedule dashboard display shows the full schedule of each room.  Ideal when you need to see the full schedules of multiple rooms at a glance.</p>
    <p class="displayModeDescription" *ngIf="overviewIllustration === 'whatsOn'">The what's on display shows all the current and upcoming meetings across multiple meeting rooms.  Ideal for a TV mounted at reception to show guests where to go.</p>

    <!-- Two illustrations rather than one with media sources: the horizontal and
         vertical renderings are different shapes, and the aspect ratio comes from
         width/height. The 900px breakpoint picks one. -->
    <app-illustration class="mainScreenIllustration horizontal" alt="Dash main screen"
                      [src]="mainScreenImage('horizontal', 'png')" [webpSrc]="mainScreenImage('horizontal', 'webp')"
                      width="2560" height="1920" [cover]="true"></app-illustration>
    <app-illustration class="mainScreenIllustration vertical" alt="Dash main screen"
                      [src]="mainScreenImage('vertical', 'png')" [webpSrc]="mainScreenImage('vertical', 'webp')"
                      width="1920" height="2560" [cover]="true"></app-illustration>

    <ol class="stepList">
      <li>
        <b>Current time - </b>Dash takes the time of day from your device's clock, which can
        be changed in your device's settings.  Dash can also display the date on the main screen.
      </li>
      <li><b>Meeting room name - </b>The name of the calendar you have selected.</li>
      <li *ngIf="overviewIllustration !== 'whatsOn'">
        <b>Current/upcoming meetings - </b>The current meeting name, duration, and number of participants is displayed.
        If there is another meeting starting in the next ten minutes, it is displayed below.
      </li>
      <li *ngIf="overviewIllustration === 'whatsOn'">
        <b>Meeting name - </b>Each current and upcoming meeting is shown on the display, along with its start and end time, ordered from earliest to latest.
      </li>
      <li>
        <b>Meeting tools (optional) - </b>These tools allow you to check in, extend, or end a meeting early.  <br><br>See
        <a routerLink="." fragment="optionalFeatures">optional features</a> for more information.
      </li>
      <li *ngIf="overviewIllustration === 'room' || overviewIllustration === 'scheduleDashboard'">
        <b>Schedule display  - </b>The schedule display shows the meeting plan for the day (or days depending on your
        settings).  It can be configured to show a list of upcoming meetings, or a calendar view of the day.  Tap on a
        meeting to view detailed information about the meeting.<br><br>The display
        is colored by the meeting status (one of <i>Free</i>, <i>Occupied</i>, or <i>Soon to be occupied</i>).
      </li>
      <li *ngIf="overviewIllustration === 'dashboard'">
        <b>Schedule display  - </b>The dashboard display doesn't show the schedule directly.  Instead, tap the calendar icon in a room to see the room's full schedule.
      </li>
      <li *ngIf="overviewIllustration === 'whatsOn'">
        <b>Schedule display  - </b>The what's on display doesn't show the schedule directly.  Instead, tap the calendar icon on a meeting to see its room's full schedule.
      </li>
      <li *ngIf="overviewIllustration === 'countdown'">
        <b>Countdown timer  - </b>Shows the amount of time remaining in the current meeting, or the amount of remaining free time if the room is unoccupied.<br><br>The timer
        is colored by the meeting status (one of <i>Free</i>, <i>Occupied</i>, or <i>Soon to be occupied</i>).
      </li>
      <li>
        <b>Book/Book now (optional) - </b>Allows you to make impromptu room bookings for up to two hours, or optionally also book
        meetings in the future.<br><br>See <a routerLink="." fragment="optionalFeatures">optional features</a> for more information.
      </li>
      <li>
        <b>Find a room (optional) - </b>Allows you to find a free meeting room in the building.  <br><br>See
        <a routerLink="." fragment="optionalFeatures">optional features</a> for more information.
      </li>
      <li>
        <b>Settings - </b>Access the app settings to select a meeting room calendar, configure optional features, or
        customize branding.  You can protect Dash's settings with an optional passcode.
      </li>
      <li>
        <b>Full schedule - </b>Tap the calendar icon to open the room's full schedule, in a separate calendar view.
      </li>
      <li>
        <b>Room attributes - </b>Optionally display the room's attributes such as capacity, available equipment, and mobility access.
      </li>
    </ol>

    <h2 class="sectionHeader" id="configuration">Configuration</h2>

    <p class="intro">The following settings allow you to customize your Dash experience.  Use them to choose the room
      calendar to display, activate and configure optional features, or control the branding and appearance of the room
      display.  The settings screen can be accessed from the <i>Configuration</i> screen by tapping the cog icon on the
      main screen.
    </p>

    <div class="settingsContainer">
      <div class="settingsCol">

        <h3 id="calendar">Calendar and display</h3>
        <h4>Calendar and events</h4>
        <p><b>Display mode - </b>Choose between five display modes for Dash: </p>
          <ul>
            <li>A <i>room display</i> which shows the status of a single meeting room calendar, along with a schedule view.</li>
            <li>A <i>countdown display</i> which shows the status of a single meeting room calendar, with a countdown timer showing the remaining time for the meeting.</li>
            <li>A <i>dashboard display</i> which shows the status of multiple meeting rooms at once.</li>
            <li>A <i>schedule dashboard display</i> which shows the full schedule of multiple meeting rooms at once.</li>
            <li>A <i>what's on display</i> which shows the current and upcoming meetings from multiple rooms.</li>
          </ul>
        <p><i>See the <a routerLink="." fragment="mainScreen">main display</a> section above for a visual overview of
        each mode</i>
        <p><b>Calendar/Calendars - </b>Select the calendar for the meeting room you would like to display (one calendar
          if <i>Display mode</i> is set to <i>room display</i> or <i>countdown display</i>, or one or more calendars if
          it is set to <i>dashboard display</i>, <i>schedule dashboard display</i>, or <i>what's on</i>).  If you do not
          see your calendar in the list, make sure that it has been added to your device by following the instructions in
          <a routerLink="/guide/officeSetup">Microsoft 365 Setup</a> or <a routerLink="/guide/googleSetup">Google Setup</a>.
        </p>
        <p class="tip icon">Some optional features (such as ending and extending meetings, and requiring user check-in) require
          write access to the calendar.  These features will not be available if a read-only calendar is selected.
        </p>

        <p><b>Rename calendars - </b>Rename your calendars, if their names are not what you would like to display in Dash.
        </p>

        <p><b>Show all-day meetings - </b>If this option is turned on then all-day meetings will be shown on the display, and will
          be included when deciding if the room is free or busy.
        </p>

        <p><b>Display only meetings accepted by the calendar - </b>If this option is selected then only meetings that have been
          accepted by the meeting room's calendar will be shown.  This is particularly useful in eliminating double
          bookings, as a second booking made in an occupied timeslot will not be shown.  This feature requires your calendar
          to automatically reject double bookings.
        </p>

        <h4>Display options</h4>

        <p><b>Status display - </b>When the <i>Display mode</i> is set to <i>Room display</i>, this setting controls how the meeting room and time are shown on the main display.  Choose
          <i>Large room name</i> to emphasize the room name, choose <i>Large meeting title</i> to emphasize the current meeting and the room's status, or choose <i>Large clock</i> to emphasize the current time.
        </p>

        <p><b>Show room occupancy by color - </b>Dash can display different colors depending on the room's current availability.
          Different colors are shown if the room is currently free, booked, or almost booked (currently free but will be booked within the next
          10 minutes).  <br><br>This option allows you to choose to have the colors displayed behind the schedule view,
          countdown timer, or room (depending on the <i>Display mode</i> you have selected), in a border around the
          whole display, or on the background of the whole display.  The colors for each state can be
          set in <a routerLink="." fragment="appearance">Appearance and branding</a>.
        </p>

        <p><b>Display meetings as - </b>When the <i>Display mode</i> is set to <i>Room display</i> or <i>Schedule dashboard</i>,
          this setting controls how your meetings are displayed on the main screen.  You have a choice of four options.
          <i>A calendar view of today's meetings</i> shows you the entire day's meetings, while also showing gaps between
          meetings.  The other three options show a list of all current and future meetings, providing a more compact view.
        </p>

        <p><b>Show meeting colors - </b>If you have a custom color for a meeting in Outlook or Google Calendar, Dash
          will show the color in the schedule view.  This feature is only supported when connected to your calendars using
          the Microsoft 365 enterprise application or Google Workspace service account connection methods.</p>

        <p><b>Show calendar view button on main screen - </b>Shows a small calendar icon/button near the bottom of the
          schedule view, or against each room if you have selected a multi-room <i>Display mode</i>.  Tapping it
          brings up a calendar view of the room so that you can see the room's full schedule.
        </p>

        <p><b>Show room attributes on main screen - </b>Shows the room's capacity and icons for
          the room's attributes (such as the presence of teleconference equipment or disabled access).
          <i>This option is only available when Dash is connected to your meeting room calendars using the Microsoft 365 Enterprise Application
          connection or Google Workspace Service Account connection</i>.  The room attributes must be set in <i>Exchange Online</i> or <i>Google Workspace Admin</i>.</p>

        <p><b>Show date on main screen - </b>Shows the current date on Dash's main screen.  You can adjust the date format in the <i>Locale</i> settings (see below).
        </p>

        <p><b>Dim screen after hours - </b>If this option is selected then Dash will dim the meeting room display after
          hours and display a screensaver showing the meeting room name and the current time.  Dash will resume when the
          screen is tapped.  Set the start and end of your working hours, as well os the days of the week when your office is occupied.
          Dash will dim the display outside your selected working hours and days.
        </p>

        <p><b>Font size - </b>Choose the size that visual elements such as buttons and text are displayed in Dash.  This
          setting has a larger effect on small text such as buttons and labels, and a smaller effect on larger text such
          as room names and headings.  <br/><br/>Dash also respects your system font scaling, so if you would like to change the
          size of all text elements equally, you can change the text size in your device's system settings.  You can use
          the system font settings and Dash's font settings at the same time for full control over the size of text in
          Dash.
        </p>

        <h4>Locale</h4>

        <p id="languages"><b>Language - </b>Choose the language used in Dash.  The following languages are available in both the main
          display and settings areas of Dash:
        </p>
        <ul>
          <li>English</li>
          <li>Danish</li>
          <li>German</li>
          <li>Portuguese (Brazil)</li>
        </ul>
        <p>And the following languages are available in the main display areas of Dash:</p>
        <ul>
          <li>Azerbaijani</li>
          <li>Czech</li>
          <li>Dutch</li>
          <li>French</li>
          <li>Hebrew</li>
          <li>Hungarian</li>
          <li>Italian</li>
          <li>Indonesian</li>
          <li>Japanese</li>
          <li>Korean</li>
          <li>Lithuanian</li>
          <li>Malay</li>
          <li>Norwegian</li>
          <li>Polish</li>
          <li>Romanian</li>
          <li>Russian</li>
          <li>Serbian</li>
          <li>Slovak</li>
          <li>Spanish (Latin America)</li>
          <li>Swedish</li>
          <li>Ukrainian</li>
        </ul>
        <p>The default language will be chosen based on your tablet's locale settings.</p>

        <p>If you have any questions
          about the languages supported, or would like to request a translation of Dash into your language, please
          <a routerLink="/contact">contact us</a>.
        </p>

        <p><b>Time format - </b>Choose whether to display times in a 12-hour or 24-hour format.  The default time format
          will be chosen based on your tablet's locale settings.
        </p>

        <p><b>Date format - </b>The format to use for dates shown in Dash (both on the main screen and for meetings).
          "Auto" chooses an appropriate format based on your device's locale, and the other options display the date
          as indicated.
        </p>

        <p class="tip icon">Note that the exact format of the date is influenced by your selected language, so we
          recommend choosing your language before selecting a date format.
        </p>

        <h3 id="subscription">Subscription</h3>
        <p>The subscription section is where you can manage your subscription to Dash Business.  If you are currently
          subscribed, tap <i>Manage subscription</i> to go to the Apple App Store or Google Play Store to manage your
          Dash subscription.  You can also upgrade or downgrade the number of devices in your subscription at any time
          by using the <i>Devices</i> slider.  Dash currently supports up to 10 devices for its in-app subscriptions.  If you
          would like to use Dash on more than 10 devices, please <a routerLink="/contact">Contact us</a></p>

        <p>On Apple devices, if you are currently subscribed to our monthly Dash Business plan and do not see your
          subscription in Dash, tap <i>Restore Purchases</i> to make sure that Dash is showing your latest subscription
          information.
        </p>

        <p>The subscription section also allows you to register your copy of Dash if you are subscribed to our <b>Dash
          Enterprise</b> plan.  To do this, tap <i>Enterprise license</i> (or <i>Pairing code</i> on Apple devices), and then enter your license key,
          or a pairing code obtained from our <a routerLink="/enterprise/dashboard">web management dashboard</a>.
        </p>

      </div>

      <div class="settingsCol">

        <h3 id="security">Security</h3>
        <p><b>Require a passcode to access settings - </b>If selected, you will be asked to enter a 4-digit security code.
          This code will be required in order to access settings from the main screen.
        </p>

        <p><b>Label meetings with - </b>This setting controls the title displayed against each meeting on the schedule display,
          and in the detailed information about each meeting.  The following options are available:
        </p>
        <ul>
          <li><b>Meeting title - </b>This is the title of the meeting, as displayed in the meeting room's calendar.</li>
          <li><b>Meeting organizer - </b>If the meeting has an organizer, then their name will be displayed (or their email
            address if their name is not available).  Meetings with no organizer will have the title "Room booked".</li>
          <li><b>No title or organizer - </b>All meetings will have the title "Room booked"</li>
        </ul>

        <p><b>Display meeting details - </b>By default, Dash will display detailed information about a meeting when it is
          clicked in the schedule display.  This detailed information includes:
        </p>
        <ul>
          <li>The meeting title</li>
          <li>The meeting description (including information about any video calls associated with the meeting).  <i>Displaying the meeting description is optional (see below)</i>.</li>
          <li>A list of attendees which may include email addresses</li>
        </ul>
        <p>Disabling the meeting details option will prevent this information being displayed to users of the display.</p>
        <p><b>Include meeting description - </b>By default, Dash will display the meeting description when the meeting
          details are displayed.  Disable this to show only the meeting title and attendee information.
        </p>

        <p><b>Enable error reporting - </b>If Dash encounters an unexpected error, you will see an error report.  Enable
          error reporting to allow the error report to be submitted to us so that we can fix the error on the next
          version of Dash.  Error reports contain basic information about your device, as well as information about the
          error.  Error reports never contain any personal information, and you will be able to review the report
          before submitting.
        </p>

        <h3 id="optionalFeatures">Optional features</h3>

        <h4>Check-in</h4>
        <p><b>Require check-in - </b>When selected, users will be required to check in to meetings when they enter the room.
          This can be done by tapping a check-in button on the main screen, and must be done within a configured amount of time <i>(see below)</i> of the
          meeting starting.  The room will be automatically removed from meetings not checked-in after this time.  The
          meeting will remain in the organizer's calendar, so the meeting itself will be unaffected.
        </p>
        <p><b>Release room after - </b>Control how long Dash will wait after the meeting's scheduled start time before
          removing the room from the meeting.  If <i>Don't release</i> is selected, the meeting will be displayed as tentative on
          the display until the check-in button is pressed but Dash won't end the meeting if it isn't checked in.
        </p>
        <p><b>Release room from recurring meetings after - </b>When a recurring meeting is not checked in to multiple
          times in a row, you can configure Dash to remove the meeting room from all further meetings in the series.
          Choose <i>Don't release</i> leave future meetings alone, or choose the number of consecutive missed check-ins
          after which the room will be removed from the series.
        </p>
        <p class="tip icon">When connected to your room calendars using the <i>Device calendar</i> or <i>Microsoft 365 business/personal account</i> connection methods, the check-in feature writes a small amount of text to the calendar event's description when the meeting is
          checked-in.
        </p>

        <h4>Booking</h4>

        <p><b>Allow booking - </b>Allows users to book the meeting room (if its schedule allows).  Choose between:
        </p>
        <ul>
          <li><b>Booking not allowed - </b>When selected, users are able to book the room (if its schedule allows).  </li>
          <li><b>Instant bookings only - </b>The room may be booked immediately for 15 minutes, 30 minutes, one hour, or two hours.</li>
          <li><b>Instant and later bookings - </b>The room may be booked immediately, and also in advance.</li>
        </ul>
        <p>When booking is enabled, then the following options can be configured:</p>
        <h4>These settings apply to all bookings:</h4>
        <p class="indent"><b>Suggested booking lengths - </b>this setting affects the length of time suggested when the user is booking the room:
        </p>
        <ul class="indent">
          <li><b>Friendly booking end times - </b>Booking lengths will be chosen so that your booking finishes at a round time (such as on the hour).</li>
          <li><b>Friendly booking lengths - </b>Round booking lengths will be suggested (for example 30 minutes or 1 hour)</li>
        </ul>

        <p class="indent"><b>Include video conferencing - </b>this setting allows you to control whether a video conference link is added to bookings made from the Dash display:
        </p>
        <ul class="indent">
          <li><b>Always - </b>A video conference link is included with all bookings.</li>
          <li><b>Never - </b>No video conference links are included with any bookings</li>
          <li><b>Per booking - </b>Dash will ask the user at the time a booking is being made</li>
        </ul>

        <p class="indent"><b>Users can add attendees when booking - </b><i>(only available for Microsoft 365 Enterprise Application connections and Google Workspace Service Account connections)</i>.  Users can add attendees (both inside and outside your organization) when booking from the Dash display.  The attendees will receive a calendar invite with a videoconferencing link.</p>

        <h4>These settings appear twice, and can be set separately for instant and later bookings:</h4>

        <p class="indent"><b>Users can set a message when booking - </b>When selected, users are able to set their own meeting title and description when making impromptu bookings.  When set to <i>Optional</i>, a default meeting title is pre-entered.  When set to <i>Required</i> there is no default title, and the user must enter a title.</p>

        <p class="indent"><b>Users can set the organizer when booking - </b><i>(only available for Microsoft 365 Enterprise Application connections and Google Workspace Service Account connections)</i>.  Users can choose a member of your organization to be the meeting's organizer.  The meeting will be created in the member's calendar and the meeting room will be set as the meeting's location.  When set to <i>Optional</i> the user can book a meeting without selecting an organizer (in which case the booking will be created in the meeting room's calendar only).  If set to <i>Required</i> then the user must choose an organizer.</p>


        <h4>Passcode</h4>
        <p class="indent"><b>Require a passcode to book from the display - </b>If turned on, this setting requires users to
          enter a 4-digit passcode before making bookings from the display.  This setting affects instant and future
          bookings, as well as bookings made from the find a free room feature.
        </p>
        <p class="indent"><b>Also require the passcode to end or extend meetings - </b>If turned on, users will also need
          to enter the passcode to make changes to meetings, such as extending them or ending them early.
        </p>

        <h4>Ending and extending</h4>

        <p><b>Allow ending active meetings - </b>When selected, users are able to end the current meeting directly from the main screen.
          It is also possible to end upcoming meetings that are starting in the next ten minutes.
        </p>

        <p><b>When ending active meetings - </b>There are two options for ending meetings:
        </p>
        <ul>
          <li><b>Delete the meeting - </b>this will completely remove the meeting from the meeting room's calendar</li>
          <li><b>Change the meeting finish time - </b>This will bring forward the meeting end time.  Note that if this would cause
            the meeting duration to be less than one minute, it will be deleted instead.</li>
        </ul>
        <p>Note that this setting does not affect the way that meetings are ended by the <i>check-in</i> feature (see below).  Meetings ended due to not being checked in are always deleted.</p>

        <p><b>Allow extending active meetings - </b>When selected, users are able to extend the current meeting (if the room
          schedule allows).  The meeting may be extended by 15 minutes, 30 minutes, one hour, or two hours.
        </p>

        <p><b>Allow ending future meetings - </b>When selected, users are able to end future meetings directly from the main screen.
          Just tap on a meeting in the schedule view (both on the main display, and when viewing the room's full calendar),
          then tap <i>Cancel meeting</i>
        </p>

        <p class="tip icon">When allowing ending or extending meetings, choosing to allow "only for meetings
          booked from a Dash display" restricts ending or extending meetings to only meetings with no organizer, or
          where the organizer is the conference room.<br><br>This is usually the case for meetings booked from the Dash
          display but can also apply to meetings booked directly in the conference room's calendar by an admin.

        </p>

        <h4>Find free rooms</h4>
        <p><b>Find free rooms - </b>When selected, users are able to search for other free rooms in the building, and also book them (if the <i>Allow Booking</i> setting is enabled).  </p>
        <p>Rooms
          that are either free now, or will be free in the next ten minutes are included in the list, and the rooms are
          ordered by the length of time available (with the longest time listed first).
        </p>

        <p><b>Rooms to check - </b>The list of calendars to search when checking for free rooms.  You may select as many
          calendars as you would like.
        </p>
        <p class="tip icon">
          If you do not see all your rooms in the list, make sure that they have been added
          to your device by following the instructions in
          <a routerLink="/guide/officeSetup">Microsoft 365 Setup</a>, <a routerLink="/guide/googleSetup">Google Setup</a>,
          or <a routerLink="/guide/exchangeCalendarSetup">Device calendar Setup</a> (depending on which method you are using to connect
          Dash to your calendars).
        </p>
      </div>

    </div>


    <h3 id="appearance">Appearance and branding</h3>
    <div class="settingsContainer">
      <div class="settingsCol">
        <p>Appearance and branding allows you to customize the appearance of Dash to match your company branding.
          You can customize the colors of most elements of the user interface, as well as choose a custom background image
          and logo for the app.
        </p>
        <p>You are able to choose custom colors for the following components:
        </p>
        <ul>
          <li><b>Background color - </b>The background color of the main display.  If you also choose a background image this color will appear behind it.</li>
          <li><b>Text color - </b>The color of text in the main display, and also in dialogs used for booking or finding rooms.</li>
          <li><b>Button color - </b>The color of buttons.</li>
          <li><b>Button border color - </b>The color of the border around buttons.  Set this to transparent for no border.</li>
          <li><b>Button text color - </b>The color of the text inside buttons.</li>
          <li><b>Dialog background color - </b>The background color of dialogs used for room booking, meeting details, and room finding.</li>
          <li><b>Room free color - </b>The color used to indicate that the room is currently free.</li>
          <li><b>Room almost booked color - </b>The color used to indicate that the room is currently free, but will be occupied in the next ten minutes.</li>
          <li><b>Room booked color - </b>The color used to indicate that the room is currently occupied.</li>
          <li><b>Schedule background color - </b>When you have set the room occupancy to be shown on a border around the display or the background of the whole display, this setting controls the background color of the schedule view.</li>
        </ul>
        <p>Each of these colors can be tested in the live preview.  The booking status of the preview can be changed
          using the toggle buttons above the main display.
        </p>
      </div>
      <div class="settingsCol">
        <app-illustration class="illustration brandingIllustration" alt="Dash branding screen"
                          src="/assets/images/branding-screenshot-wide_small.png" [sources]="brandingSources"
                          width="900" height="675" [cover]="true"></app-illustration>
        <p>Dash allows you to set a <b>custom background image</b> for the display.  This can contain your logo, or other company
        colors and imagery, and can be used to further personalize the display with your branding.</p>
        <p>It is recommended that you use an image with the same aspect ratio as your device, but if a different aspect
          ratio is used then Dash will scale the image so that the view is always entirely filled.
        </p>
        <p class="tip icon">
          For best results, you should create an image that exactly matches the size of your device's display in pixels.
          This ideal size for your device is shown underneath the <i>Background image</i> option.
        </p>
        <p>
          Dash also allows you to display a <b>custom logo</b>.  The chosen logo will appear at the top of the main screen.
          You can choose from three logo sizes (small, medium, and large) and the ideal image size will be displayed below
          the option. If you use an image with a different size, it will be scaled to fit and aligned to the left.
          If you would like to have your logo appear in a different part of the main display you can add it to your
          background image.
        </p>
      </div>
    </div>


    <h2 class="sectionHeader" id="bookingAndCheckIn">Booking and check-in</h2>
    <p class="intro">Book your room from the screen, find free rooms close by, and clear unused bookings automatically.
      Learn how to use Dash's advanced features to manage your meeting spaces.  All advanced features are optional, so
      make sure that you have activated and configured them by following the configuration instructions above.</p>

    <div class="settingsContainer">
      <div class="settingsCol">
        <h3 id="booking">Booking</h3>
        <p>The booking controls can be found at the bottom right corner of the main display (for horizontal devices),
          or at the bottom of the display (for vertical devices).  To book the room, tap the button labeled
          <i>Book now</i>.
        </p>

        <p>You will be presented with a booking screen showing four approximate durations: 15 minutes, 30 minutes, 1 hour, and
          2 hours.  Tap the length of time you would like to book, and a booking will be made with the title
          "Manually booked".
        </p>

        <p>If you have chosen to allow booking the room in advance, there will also be a button <i>Book a later time</i>.
          Tapping this button will bring up a calendar display (showing a week on larger devices, or a day on smaller devices).
        </p>

        <p>Move the calendar view backward and forward in time by pressing the arrow buttons on either side of the
          dates, or choose a date from the picker by tapping on the month displayed in the center of the screen.  To make
          a booking, tap on an empty space in the schedule, and drag the booking to refine.  When you're done, press the
          <i>Book</i> button at the bottom of the screen.  Note that users are always able to set the title and
          description of advance bookings, regardless of the value set for <i>Users can set a message when booking</i>
          in <i>Settings</i>.
        </p>

        <p class="tip icon">If the room is currently booked, impromptu booking will
          be disabled.  If future booking is enabled, Dash will launch the calendar view without showing the impromptu
          booking screen.
        </p>
        <app-illustration class="illustration bookingIllustration" alt="Dash booking screen"
                          src="/assets/images/using-dash-booking.png"
                          width="1122" height="558" [cover]="true"></app-illustration>


        <h3 id="checkIn">Check-in</h3>
        <p>The check-in feature requires all meetings to be manually checked-in when they start.  To check in a meeting,
          click the <i>Check in</i> button in the current/upcoming meetings section of the main screen.
        </p>
        <p>If a meeting is not checked-in within the configured time (set in the <i>Release room after</i> option), the room will be automatically removed from the meeting to free the
          space for other uses.  The meeting will remain in the organizer's calendar so that attendees in other locations can still attend.
        </p>
        <p>For recurring meetings, if the <i>Release room from recurring meetings after</i> option is enabled, Dash will also remove the
          meeting room from any future occurrences once the meeting has missed the configured number of
          check-ins in a row.</p>

      </div>

      <div class="settingsCol">
        <h3 id="extend">Extending and ending meetings</h3>
        <p>The current meeting can be extended if there is space in the room's schedule.  To extend a meeting, tap the
        <i>Extend</i> button in the current/upcoming meetings section of the main screen.
        </p>
        <p>You will be presented with a screen similar to the booking screen, showing four durations: 15 minutes,
          30 minutes, 1 hour, and 2 hours.  Tap the length of time you would like to extend, and the booking will be
          adjusted.
        </p>
        <p>The current meeting can also be ended by tapping the <i>End now</i> button.  The meeting will either be
          removed from your calendar, or edited to end at the current time, depending on the setting you chose for
          <i>When ending meetings</i> in the settings screen.
        </p>
        <app-illustration class="illustration extendIllustration" alt="Extending and ending meetings in Dash"
                          src="/assets/images/using-dash-extend.png"
                          width="1122" height="558" [cover]="true"></app-illustration>

        <h3 id="findRooms">Find a room</h3>
        <p>Before using this feature, you need to select the calendars you would like to check (see the <i>Rooms to check</i>
          option in the <i>Configuration</i> settings described above).
        </p>
        <p>The free rooms controls can be found in the bottom right corner of the main display (for horizontal devices),
          or at the bottom of the display (for vertical devices).  To find a free room, tap the button labeled
          <i>Find a room</i>.
        </p>
        <p>You will be presented with a booking screen showing all free rooms found.  The list is ordered with the rooms
          having the most free time appearing first.  Tap a free room to view its schedule, then tap <i>Book now</i> to
          book it for your desired amount of time.
        </p>
        <app-illustration class="illustration findRoomsIllustration" alt="Dash find free rooms screen"
                          src="/assets/images/using-dash-free-rooms.png"
                          width="1122" height="558" [cover]="true"></app-illustration>



      </div>
    </div>


  </div>
</div>


<div class="content practices" *ngIf="selectedArticle === 'practices'">
  <div class="contentInner">
    <h1 class="sectionHeader">Practices</h1>
    <p class="intro">These tips will help you get the most out of Dash by making sure that you're using your meeting rooms as efficiently as possible.</p>

    <h2 class="subHeading">Always respect bookings</h2>
    <p>Systems work the best when everyone understands them, and everyone follows them equally.  To this end, we
      recommend the following rules for meeting room bookings:</p>
    <ul>
      <li><b>Always make a booking when using a room</b> even for a 15-minute impromptu meeting.  This ensures
        that everyone in your organization knows the room is taken, and don't come halfway across the building only to
        find a meeting already in progress.  You can reserve a room directly from the display using Dash's
        <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">Book now</a> feature.</li>
      <li><b>Clear your booking if your meeting finishes early</b> to allow everyone else to know that the room is free.
        You can end a meeting directly from the display using Dash's
        <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">End now</a> feature.</li>
      <li><b>If you do not have a booking and someone else does, give the room up to them.</b>  This works best when
        followed by everyone in the company, from the C.E.O. to an intern.  It encourages everyone to use the booking
        system (see above), and that they've allocated the appropriate amount of time to their meeting.  For meetings that run over, you
        can always use Dash to <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">extend</a> them.  If you
        need a meeting space that is booked, you can negotiate in advance with the booking owner to change the time or
        location of their booking.</li>
      <li><b>Use the <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">Check-in</a> feature</b> to ensure that meeting bookings are adhered to.  Since a meeting will be
        cleared if not checked-in within 10 minutes of its start time, attendees are encouraged to start the meeting on
        time - eliminating wasted space.</li>
    </ul>

    <h2 class="subHeading">Different rooms for different purposes</h2>
    <p>Different rooms can be suitable for different purposes.  For example, a large meeting will not fit in a two
      person room, and a two person meeting can be a waste of resources if booked in a large room.  Facilities such as
      teleconferencing can also make a room more suitable for particular meetings.</p>
    <p>It can be useful to publish information on the size and facilities offered in each meeting room in your organization,
      and to include a guide on the types of meetings appropriate for each one.</p>

    <h2 class="subHeading">Meeting efficiency</h2>
    <p>Inefficient meetings can be one of the biggest productivity costs in any business.  Dash can help you by making
      sure the space is available for you, but we also recommend considering the following tips to maximize the value
      you get from your meetings:</p>
    <ul>
      <li><b>Keep meetings short - </b>A poorly structured meeting can easily run over time.  While it is easy to extend
        a meeting with Dash it is important to think about whether it's a good idea to.</li>
      <li><b>Have a clear purpose - </b>Everyone should know why they are at a meeting, and what you hope to achieve.</li>
      <li><b>Prepare in advance - </b>Meetings are best used for collaboration, so it can be helpful to send out
        information beforehand, and then reserve meeting time for discussion.</li>
      <li><b>End a meeting by listing next steps - </b>To ensure progress from each meeting, it can be helpful to list
        next steps.  These tasks and goals can be assigned to individuals or the team as a whole.</li>
      <li><b>Review who needs to attend - </b>Meetings form a large percentage of employee's time, which can then not be
        spent on their regular tasks.  Consider whether each invitee needs to be present at the meeting, or whether a
        meeting summary or minutes might be sufficient.</li>
    </ul>
  </div>
</div>

<div class="content practices" *ngIf="selectedArticle !== null">
  <div class="contentInner">
    <div class="tip icon">
      <h2>Managing multiple rooms?</h2>
      <p>Dash Enterprise lets you configure every display from one place instead of individually on each device.  Deploy
        and configure Dash through our web management dashboard or your MDM system of choice.
      </p>
      <p>
        Dash Enterprise also includes detailed room analytics so you can see how your meeting spaces are used.
      </p>
      <p>
        We offer a fully-featured free trial - <a routerLink="/contact">contact us</a> to try Dash Enterprise free for one month.
      </p>
      <span style="display: flex; flex-direction: row; justify-content: center">
          <a routerLink="/about-enterprise" [queryParams]="{ utm_source: 'docs'}" class="button" style="margin-top: 0">Learn about Dash Enterprise</a>
        </span>
    </div>
  </div>
</div>
